import React from 'react'
import '../../scss/variables.scss'
import '../../scss/reset.scss'
import './NavbarLogo.scss'
import { Link } from 'react-router-dom'


/* ===Import IMGS=== */
import FadyLogo from '../../assets/images/Logo-Fady.svg'
import Hamburger from '../../assets/images/Hamburger.svg'

function NavbarLogo() {
    return (
        <nav>
            <Link to="/">
                <img src={FadyLogo} className="FadyLogo" alt="FadyLogo" />
            </Link>
            <img src={Hamburger} className="Hamburger" id="HamburgerID" alt="Menu" />
        </nav> 
    )
}

export default NavbarLogo